import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Card, Icon, fmtNum } from "../ui";
import content from "../../services/api-content";
import { useToast } from "../../context/ToastContext";
import Comments from "./Comments";
import ReportModal from "./ReportModal";
import "../../styles/content.css";

const VIDEO = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
/** media อาจเป็น string URL หรือ {type,url} — รับเฉพาะ http(s) */
export const normMedia = (m) => {
  const url = typeof m === "string" ? m : m?.url;
  if (!/^(https?:|data:image\/|blob:)/i.test(String(url || ""))) return null;
  const type = typeof m === "object" && m.type ? m.type : VIDEO.test(url) ? "video" : "image";
  return { url, type };
};

export const when = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleString("th-TH", { dateStyle: "medium", timeStyle: "short" });
};

export function Media({ items }) {
  const list = (items || []).map(normMedia).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="post__media">
      {list.map((m) => (m.type === "video" ? <video key={m.url} src={m.url} controls preload="metadata" playsInline /> : <img key={m.url} src={m.url} alt="" loading="lazy" />))}
    </div>
  );
}

export default function PostCard({ p, meId, isSuper, onDeleted }) {
  const toast = useToast();
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(Number(p.likeCount) || 0);
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState(Number(p.commentCount) || 0);
  const [report, setReport] = useState(false);
  const like = async () => {
    try { const r = await content.posts.like(p.id); setLiked(r.liked); setLikes(r.likeCount ?? likes + (r.liked ? 1 : -1)); } catch (e) { toast(e.message, "error"); }
  };
  const del = async () => {
    if (!window.confirm("ลบโพสต์นี้?")) return;
    try { await content.posts.remove(p.id); onDeleted?.(p.id); } catch (e) { toast(e.message, "error"); }
  };
  return (
    <Card className="post">
      <div className="row">
        <Avatar name={p.userName} src={p.userPhoto} size={40} />
        <div className="grow">
          <Link to={`/creator/${p.userId}`} className="strong">{p.userName || "ผู้ใช้"}</Link>
          <div className="faint" style={{ fontSize: 12 }}>{when(p.createdAt)} · {p.visibility === "private" ? "ส่วนตัว" : "สาธารณะ"}</div>
        </div>
        {(p.userId === meId || isSuper) ? <button type="button" className="act" onClick={del} aria-label="ลบโพสต์">ลบ</button> : <button type="button" className="act" onClick={() => setReport(true)} aria-label="รายงานโพสต์">รายงาน</button>}
      </div>
      {p.text ? <p className="mt-16" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{p.text}</p> : null}
      <Media items={p.media} />
      {(p.characterIds || []).length ? <div className="chip-row mt-16">{p.characterIds.map((id) => <Link key={id} to={`/c/${id}`} className="chip chip--sm">ตัวละครที่แท็ก →</Link>)}</div> : null}
      <div className="row mt-16">
        <button type="button" className={`act${liked ? " is-on" : ""}`} aria-pressed={liked} onClick={like}><Icon name="heart" size={16} filled={liked} /> {fmtNum(likes)}</button>
        <button type="button" className="act" aria-expanded={open} onClick={() => setOpen((v) => !v)}><Icon name="chat" size={16} /> {fmtNum(comments)}</button>
      </div>
      {open ? <div className="mt-16"><Comments targetType="post" targetId={p.id} ownerId={p.userId} meId={meId} isSuper={isSuper} onCount={setComments} /></div> : null}
      <ReportModal open={report} onClose={() => setReport(false)} targetType="post" targetId={p.id} title="รายงานโพสต์" />
    </Card>
  );
}
